import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';
import {
  CheckCircleOutlined,
  Check,
  Close,
  EditOutlined,
  BlockOutlined,
  DeleteOutlined
} from '@mui/icons-material';
import {
  headCellSx,
  bodyCellSx,
  inputSx,
  disabledTextSx,
  actionIconSx,
  checkIconSx,
  closeIconSx,
  tableBodyRowSx
} from './styles';

const rows = [
  { medication: 'Biotin Supplement', dose: '10', direction: '1-0-0', disabled: false },
  { medication: 'Telekast', dose: '10', direction: '0-1-0', disabled: false },
  { medication: 'Lisinopril', dose: '20', direction: '0-0-1', disabled: false },
  { medication: 'Omeprazole', dose: '20', direction: '0-0-1', disabled: true },
  { medication: 'Atorvastatin', dose: '40', direction: '1-0-0', disabled: true }
];

const MedicationTable = ({ showAddRow, onCancelAdd }) => {
  return (
    <Table size="small" sx={{ tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          <TableCell sx={headCellSx}>Medication</TableCell>
          <TableCell sx={headCellSx}>Dose</TableCell>
          <TableCell sx={headCellSx}>Direction</TableCell>
          <TableCell align="center" sx={{ ...headCellSx, width: 120 }}>
            Actions
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {showAddRow && (
          <TableRow sx={{...tableBodyRowSx}}>
            <TableCell sx={{...bodyCellSx,height:52}}>
              <TextField fullWidth placeholder="Medication" sx={inputSx} />
            </TableCell>
            <TableCell sx={{...bodyCellSx,height:52}}>
              <TextField fullWidth placeholder="Dose" sx={inputSx} />
            </TableCell>
            <TableCell sx={{...bodyCellSx,height:52}}>
              <TextField fullWidth placeholder="Direction" sx={inputSx} />
            </TableCell>
            <TableCell align="center" sx={{...bodyCellSx,height:52}}>
              <IconButton size="small" sx={checkIconSx}>
                <Check />
              </IconButton>
              <IconButton size="small" sx={closeIconSx} onClick={onCancelAdd}>
                <Close />
              </IconButton>
            </TableCell>
          </TableRow>
        )}

        {rows.map(row => (
          <TableRow key={row.medication} sx={tableBodyRowSx}>
            <TableCell sx={{ ...bodyCellSx, ...(row.disabled && disabledTextSx) }}>
              {row.medication}
            </TableCell>
            <TableCell sx={{ ...bodyCellSx, ...(row.disabled && disabledTextSx) }}>
              {row.dose}
            </TableCell>
            <TableCell sx={{ ...bodyCellSx, ...(row.disabled && disabledTextSx) }}>
              {row.direction}
            </TableCell>
            <TableCell align="center" sx={{...bodyCellSx, ...(row.disabled && disabledTextSx) }}>
              {row.disabled ? (
                <>
                  <IconButton size="small" sx={actionIconSx}>
                    <CheckCircleOutlined />
                  </IconButton>
                  <IconButton size="small" sx={actionIconSx}>
                    <DeleteOutlined />
                  </IconButton>
                </>
              ) : (
                <>
                  <IconButton size="small" sx={actionIconSx}>
                    <EditOutlined />
                  </IconButton>
                  <IconButton size="small" sx={actionIconSx}>
                    <BlockOutlined />
                  </IconButton>
                </>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

MedicationTable.propTypes = {
  showAddRow: PropTypes.bool,
  onCancelAdd: PropTypes.func
};

export default MedicationTable;